<template>
  <v-container grid-list-xs>
    <v-card>
      <v-tabs v-model="tab" bg-color="primary" color="white">
        <v-tooltip location="bottom" text="Acesso">
          <template v-slot:activator="{ props }">
            <v-tab :value="1" v-bind="props">
              <v-icon>mdi-key</v-icon>
            </v-tab>
            </template>
          </v-tooltip>
        <v-tooltip location="bottom" text="Dados cadastrais">
          <template v-slot:activator="{ props }">
            <v-tab :value="2" v-bind="props">
              <v-icon>mdi-clipboard-file</v-icon>
            </v-tab>
            </template>
          </v-tooltip>
        <v-tooltip location="bottom" text="Configurações da plataforma">
          <template v-slot:activator="{ props }">
            <v-tab :value="4" v-bind="props">
              <v-icon>mdi-cog</v-icon>
            </v-tab>
            </template>
          </v-tooltip>
        
      </v-tabs>

      <v-card-text>
        <v-window v-model="tab">
          <v-window-item :value="1">
            <FormUser v-if="me && me.id && me.email" :user="user" :editUser="me" @updated="updatedUser"/>
            <div v-else class="text-center">
              <p>
                Não foi possível acessar seus dados, verifique sua conexão com a
                internet e clique em recarregar.
              </p>
              <v-btn @click="loadUser" :disabled="requestingApi" color="primary"
                >Recarregar <v-icon class="ml-2">mdi-sync</v-icon></v-btn
              >
            </div>
          </v-window-item>
          <v-window-item :value="2">
            <FormularioCadastro :user="user" :me="me" @updated="updatedLegalPerson" :admin="false"/>
          </v-window-item>
          <v-window-item :value="4">
            <p class="text-subtitle-1">
              Alterar tema:
              <v-btn
                :color="$vuetify.theme.current.dark ? 'white' : 'black'"
                @click="swapLightDarkTheme()"
                ><v-icon class="mr-2">mdi-theme-light-dark</v-icon>
                {{ $vuetify.theme.current.dark ? "light" : "dark" }}</v-btn
              >
            </p>
          </v-window-item>
        </v-window>
      </v-card-text>
    </v-card>
    <v-row style="margin-top: 80px">
      <v-col cols="12 mt-10 mb-3" class="text-center">
        <v-btn
          :disabled="requestingApi"
          color="warning"
          size="small"
          @click="logout()"
          >Sair (desconectar)<v-icon class="ml-2">mdi-logout</v-icon></v-btn
        >
      </v-col>
    </v-row>
    <div class="text-center mt-10">
      <p class="text-caption">
        <span @click="deleteAccount()" class="text-red fakeLink"
          >Excluir permanentemente minha conta</span
        >
      </p>
    </div>
  </v-container>
</template>
<script>
import FichaMedica from '../components/FichaMedica.vue';
import FormularioCadastro from '../components/FormularioCadastro.vue';
import FormUser from '../components/FormUser.vue';
import api from '@/services'
export default {
  components: { FormularioCadastro, FichaMedica, FormUser },
  props: {
    user: Object,
  },
  data() {
    return {
      requestingApi: null,
      tab: 1,
      me: {},
    };
  },
  mounted() {},
  activated() {
    var vm = this
    vm.me = api.auth.user()
  },
  methods: {
    swapLightDarkTheme() {
      var vm = this;
      let _dark = vm.$vuetify.theme.current.dark;
      if (_dark) {
        vm.$vuetify.theme.change("light");
        localStorage._dark = 0;
      } else {
        vm.$vuetify.theme.change("dark");
        localStorage._dark = 1;
      }
    },
    loadUser() {
      var vm = this;
      vm.requestingApi = true;
      return new Promise((resolve, reject) => {
        api.auth
          .me()
          .then((result) => {
            vm.me = result || {};
            vm.$emit("loggedIn", result);
          })
          .catch((err) => {
            if (err.message) {
              vm.$notify({
                type: "warn",
                text: err.message,
              });
            }
          })
          .finally(() => {
            vm.requestingApi = false;
          });
      });
    },
    updatedLegalPerson(data) {
      var vm = this
        vm.loadUser()
    },
    updatedUser(resultUser) {
      var vm = this;
      vm.$emit("loggedIn", resultUser);
    },
    logout() {
      var vm = this;
      api.auth.logoutAndRedirect()
    },
    deleteAccount() {
      var vm = this;
      let _delete = confirm(
        "Você tem certeza que deseja excluir PERMANENTEMENTE sua conta?"
      );
      if (_delete) {
        let _really = confirm(
          "Você TEM CERTEZA? Esta ação não poderá ser desfeita!"
        );
        if (_really) {
          let _areYouSure = confirm(
            "Todos os seus dados erão excluídos da plataforma e o único jeito de acessar será c riando uma nova conta. Deseja realmente fazer isto?"
          );
          if (_areYouSure) {
            vm.requestingApi = true;
            api.auth
              .deleteMe()
              .then((result) => {
                vm.$notify({
                  type: "info",
                  text: "Sua conta foi excluída com sucesso",
                });
                vm.logout();
              })
              .catch((err) => {
                if (err.message) {
                  vm.$notify({
                    type: "warn",
                    text: err.message,
                  });
                }
              })
              .finally(() => {
                vm.requestingApi = false;
              });
          }
        }
      }
    },
  },
  watch: {},
};
</script>